import { Controller } from '@hotwired/stimulus';

import RollupController from './rollup-table-controller';

import SelfDirectedPortfolio from '../models/self-directed-portfolio';

export default class extends Controller {
  static targets = ['rollupTable', 'submitButton', 'advice'];

  declare rollupTableTarget: HTMLElement;

  declare submitButtonTarget: HTMLButtonElement;

  declare adviceTarget: HTMLElement;

  connect() {
    this.connectInputListener();
  }

  disconnect() {
    this.disconnectInputListener();
  }

  connectInputListener() {
    this.rollupTableTarget.addEventListener('input', this.refresh.bind(this));
  }

  disconnectInputListener() {
    this.rollupTableTarget.removeEventListener('input', this.refresh.bind(this));
  }

  refresh() {
    this.toggleSubmitButton();
    this.toggleInvalidAdvice();
    this.triggerFormRefresh();
  }

  toggleSubmitButton() {
    if (this.portfolio.isValid()) {
      this.submitButtonTarget.removeAttribute('disabled');
    } else {
      this.submitButtonTarget.setAttribute('disabled', 'disabled');
    }
  }

  triggerFormRefresh() {
    if (this.portfolio.isValid()) {
      const event = new Event('change', { bubbles: true });
      this.refreshableElement!.dispatchEvent(event);
    }
  }

  toggleInvalidAdvice() {
    const isValid = this.portfolio.isValid();
    this.adviceTarget.classList.toggle('invalid', !isValid);
    this.rollupTableController.setValid(isValid);
  }

  get refreshableElement() {
    return this.element.querySelector('#refresh');
  }

  get rollupTableController() {
    return this.application.getControllerForElementAndIdentifier(
      this.rollupTableTarget,
      'rollup-table'
    ) as RollupController;
  }

  get portfolio() {
    const components = this.rollupTableController.values;
    return new SelfDirectedPortfolio(components);
  }
}
